import { PRODUCTS_LIST } from '../utils/products.list'

export default class CornerFormModel {
  name = PRODUCTS_LIST.ALVEOLAR;

  constructor () {
    this.size = {
      depth: null,
      length: null,
      separators: null
    }
    this.amount = null
    this.additionalNotes = null
  }
}
